const options = {
  5: "bg-zinc-800/5",
  10: "bg-zinc-800/10",
  25: "bg-zinc-800/25",
  50: "bg-zinc-800/50",
  75: "bg-zinc-800/75",
  90: "bg-zinc-800/90",
  100: "bg-zinc-800",
};

const from = {
  5: "from-zinc-800/5",
  10: "from-zinc-800/10",
  25: "from-zinc-800/25",
  50: "from-zinc-800/50",
  75: "from-zinc-800/75",
  90: "from-zinc-800/90",
  100: "from-zinc-800",
};

export default function getBackgroundZinc800(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
